import { useNavigate } from "react-router-dom";
import { Card, List, Tag, message } from "antd";
import { isMobileOnly } from "react-device-detect";
import {
  getBackgroundColor,
  decodeIfEncoded,
} from "../../../helpers/formatters";

const MyUsageList = ({ data, reportType }) => {
  const navigate = useNavigate();

  const handleItemClick = (item) => {
    const encodedSearchString = encodeURIComponent(
      decodeIfEncoded(item?.search_string)
    );
    const encodedAddress = encodeURIComponent(
      decodeIfEncoded(item?.report_address)
    );
    const encodedPropType = encodeURIComponent(
      decodeIfEncoded(item?.prop_type)
    );
    const encodedCode = encodeURIComponent(decodeIfEncoded(item?.code));

    if (reportType === "avv" && item?.status?.toLowerCase() === "completed") {
      navigate(
        `/report/${encodedSearchString}/address/${encodedSearchString.slice(
          -5
        )}`
      );
    } else if (reportType === "avv") {
      message.warning("AVV reports are not available at this time.");
    } else {
      navigate(`/report/${encodedAddress}/${encodedPropType}/${encodedCode}`);
    }
  };

  const renderTag = (item) => (
    <Tag color={getBackgroundColor(reportType, item)}>
      <span style={{ color: "black" }}>
        {reportType === "property" && item?.avv
          ? `AVV Report: ${item?.avv?.status}`
          : item?.status || "ValPro Report Completed"}
      </span>
    </Tag>
  );

  const renderAddress = (address) => {
    const [firstPart, secondPart] = address?.split(",") || [];
    return (
      <>
        <b>{firstPart}</b>
        <br />
        {secondPart}
        <br />
        <br />
      </>
    );
  };

  return (
    <List
      grid={{
        gutter: isMobileOnly ? 16 : 24,
        column: isMobileOnly ? 1 : 4,
      }}
      dataSource={data}
      renderItem={(item) => (
        <List.Item>
          <Card
            hoverable
            style={{
              margin: "10px 0",
              height: "150px",
              borderRadius: "10px",
              boxShadow: "0 0 10px rgba(0,0,0,0.2)",
              backgroundColor: getBackgroundColor(reportType, item),
              textAlign: "center",
              cursor: "pointer",
            }}
            onClick={() => handleItemClick(item)}
          >
            {reportType === "avv"
              ? renderAddress(item?.search_string)
              : renderAddress(item?.report_address)}
            {renderTag(item)}
          </Card>
        </List.Item>
      )}
    />
  );
};

export default MyUsageList;
